<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <p class="text-center">
          <img src="@/assets/logo.png" width="200" height="200" />
        </p>

        <v-card flat v-if="!newPassRequired">
          <v-form v-model="valid" @submit.prevent="signIn">
            <v-card-text>
              <v-text-field ref="username" prepend-icon="fas fa-user" name="username" label="メールアドレス" type="text" v-model="editedItem.username" :rules="[rules.required, rules.email]"></v-text-field>
              <v-text-field 
                ref="password" 
                id="password" 
                prepend-icon="fas fa-lock" 
                name="password" 
                label="パスワード" 
                type="password" 
                v-model="editedItem.password" 
                :rules="[rules.required]"
                autocomplete="password">
              </v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn type="submit" color="primary" :disabled="!valid" :loading="loading">
                <v-icon left>fas fa-sign-in-alt</v-icon>ログイン
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
            <p class="text-center mt-5">
              <router-link to="/forgot">パスワードを忘れた方</router-link>
            </p>
          </v-form>
        </v-card>

        <v-card flat v-if="newPassRequired">
          <v-form v-model="newpassValid" @submit.prevent="newPass">
            <v-card-text>
              <v-text-field
                ref="newpass"
                v-model="editedItem.newpass"
                type="password"
                label="新しいパスワード"
                :rules="[rules.required, rules.min8Char]"
                autocomplete="newpass"
                prepend-icon="fas fa-lock"></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn type="submit" color="primary" :disabled="!newpassValid" :loading="loading">
                <v-icon left>fas fa-sign-in-alt</v-icon>パスワード更新
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-form>
        </v-card>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { Auth, API, graphqlOperation } from 'aws-amplify'
import { getUser } from '../graphql/queries'

export default {
  data() {
    return {
      editedItem: {
        username: null,
        password: null,
        newpass: null,
      },
      valid: false,
      loading: false,
      newpassValid: false,
      newPassRequired: false,
      currentUser: null,
    }
  },
  props: {

  },
  computed: {
    form() {
      let form = Object.assign({}, this.editedItem)
      return form
    }
  },
  methods: {
    //サインイン
    async signIn() {
      try {
        this.loading = true
        this.currentUser = await Auth.signIn(this.editedItem.username, this.editedItem.password)
        //パスワードの再認証
        if (this.currentUser.challengeName == 'NEW_PASSWORD_REQUIRED') {
          this.newPassRequired = true

        //認証成功
        } else {
          this.getMySelf()
        }
        this.loading = false
      } catch (error) {
        console.log(error)
        this.invalid('メールアドレスまたはパスワードが間違っています。')
      }
    },
    //新しいパスワードの設定
    async newPass() {
      try {
        this.loading = true
        this.currentUser = await Auth.completeNewPassword(this.currentUser, this.editedItem.newpass)
        this.myAlert('パスワードを更新しました', 'success')
        this.newPassRequired = false
        this.loading = false
      } catch (error) {
        console.log(error)
        this.invalid('このアカウントはご利用いただけません。')
      }
    },
    //ログインユーザーの取得
    async getMySelf() {
      const myself = await API.graphql(graphqlOperation(getUser, {id: this.currentUser.username }))
      if (myself.data.getUser.enabled) {
        this.success()
      } else {
        this.invalid('このアカウントはご利用いただけません。')
      }
    },
    success() {
      this.$router.push('/')
    },
    invalid(mess) {
      this.editedItem.password = ''
      this.loading = false
      this.myAlert(mess)
    }
  }
}
</script>

<style scoped>

</style>
